import { combineReducers } from 'redux';
import feed from './feed';
import primarySpotId from './primarySpotId';
import subregionId from './subregionId';
import overview from './overview';

export default combineReducers({
  feed,
  primarySpotId,
  subregionId,
  overview,
});



// WEBPACK FOOTER //
// ./src/reducers/subregion/index.js